import { UPDATE_ACCOUNT_DETAILS } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ACCOUNT_DETAILS: {
      return action.payload;
    }
    default:
      return state;
  }
};
